import React from "react";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import TableLoader from "../LoadingSpinner/LoadingSpinner";
import LotiFiles from "../Lotifiles/LotiFiles";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const TransactionDay = ({ day_payment_list, isLoading, state }) => {
  const navigate = useNavigate();

  let total_paid_amount = 0;
  let total_expenses_amount = 0;

  for (let i = 0; i < day_payment_list?.list?.length; i++) {
    total_paid_amount += day_payment_list?.list[i]?.paid_amount;
  }
  for (let i = 0; i < day_payment_list?.list?.length; i++) {
    total_expenses_amount += day_payment_list?.list[i]?.expenses_amount;
  }

  return (
    <div>
      <div className="payment-middle">
        <span className="payment-top-left-title">DAILY TRANSACTION</span>
      </div>
      <div className="cat-content-middle">
        {isLoading ? (
          <TableLoader />
        ) : (
          <div className="content-middle-main">
            {day_payment_list?.list?.length > 0 ? (
              <Table>
                <Thead>
                  <Tr>
                    <Th className="content-middle-title-tr">
                      Dates [{state.month}]
                    </Th>
                    <Th className="content-middle-title-tr">Income</Th>
                    <Th className="content-middle-title-tr">Expense</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {day_payment_list && day_payment_list?.list?.length > 0
                    ? day_payment_list?.list?.map((item, index) => {
                        return (
                          <Tr>
                            <Td
                              className="cat-content-middle-name-data customer-name"
                              onClick={() => {
                                navigate(
                                  "/transaction-year/transaction-month/transaction-day/transaction-ofday",
                                  {
                                    state: {
                                      day: item.date,
                                      month: state.month,
                                      year: state.year,
                                    },
                                  }
                                );
                              }}
                            >
                              {item?.date !== ""
                                ? moment(item?.date).format("DD-MM-YYYY")
                                : "-"}
                            </Td>
                            <Td
                              className="cat-content-middle-active-data"
                              style={{ color: "#00D100", fontWeight: "bold" }}
                            >
                              {item?.paid_amount !== ""
                                ? item?.paid_amount?.toFixed(2)
                                : "-"}
                            </Td>
                            <Td
                              className="cat-content-middle-action-data"
                              style={{ color: "#D10000", fontWeight: "bold" }}
                            >
                              {item?.expenses_amount !== ""
                                ? item.expenses_amount?.toFixed(2)
                                : "-"}
                            </Td>
                          </Tr>
                        );
                      })
                    : ""}
                  <Tr
                    style={{
                      fontWeight: "bold",
                      backgroundColor: "#FFD68A",
                      marginTop: "1px",
                    }}
                  >
                    <Td
                      className="cat-content-middle-name-data"
                      style={{
                        fontSize: "20px",
                      }}
                    >
                      TOTAL
                    </Td>
                    <Td
                      className="cat-content-middle-name-data"
                      style={{
                        color: "#00D100",
                        fontWeight: "bold",
                        fontSize: "20px",
                      }}
                    >
                      {total_paid_amount?.toFixed(2)}
                    </Td>
                    <Td
                      className="cat-content-middle-name-data"
                      style={{
                        color: "#D10000",
                        fontWeight: "bold",
                        fontSize: "20px",
                      }}
                    >
                      {total_expenses_amount?.toFixed(2)}
                    </Td>
                  </Tr>
                </Tbody>
              </Table>
            ) : (
              <LotiFiles message={"No Data Found For Payment!"} />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TransactionDay;
